var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#1E073A",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.25C10.0663 1.25 12.0913 1.424 14.0623 1.7585C14.462 1.826 14.75 2.1755 14.75 2.5805V3.3635C14.75 3.58511 14.7064 3.80455 14.6216 4.00928C14.5367 4.21402 14.4124 4.40005 14.2557 4.55675L10.1818 8.63075C10.0251 8.78745 9.90075 8.97348 9.81595 9.17822C9.73114 9.38296 9.6875 9.6024 9.6875 9.824V12.0193C9.68756 12.3327 9.6003 12.64 9.43551 12.9067C9.27071 13.1734 9.0349 13.3888 8.7545 13.529L6.3125 14.75V9.824C6.3125 9.6024 6.26886 9.38296 6.18405 9.17822C6.09925 8.97348 5.97495 8.78745 5.81825 8.63075L1.74425 4.55675C1.58755 4.40005 1.46325 4.21402 1.37845 4.00928C1.29364 3.80455 1.25 3.58511 1.25 3.3635V2.5805C1.25 2.1755 1.538 1.826 1.93775 1.7585C3.94068 1.41939 5.96857 1.24929 8 1.25Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.b5a1e7560f6bd3b7f05fdf6eb6ba3d06.svg";
export { ForwardRef as ReactComponent };